import React from 'react';

const Contact = () => {
  return (
    <div>
      <h1>Call me maybe?</h1>
      <p></p>
    </div>
  );
};

export default Contact;